import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScrollToBottomProps {
  visible: boolean;
  onClick: () => void;
}

export function ScrollToBottom({ visible, onClick }: ScrollToBottomProps) {
  return (
    <button
      onPointerDown={(e) => e.preventDefault()}
      onClick={onClick}
      className={cn(
        "absolute left-1/2 -translate-x-1/2 -top-10",
        "flex items-center justify-center",
        "h-8 w-8 rounded-full",
        "bg-[hsla(var(--surface-hue),var(--surface-sat),14%,0.65)] backdrop-blur-md",
        "ring-1 ring-white/[0.06]",
        "text-daydra-muted hover:text-daydra-dim",
        "transition-all duration-normal",
        "z-[5]",
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-2 pointer-events-none",
      )}
      aria-label="Scroll to bottom"
    >
      <ArrowDown size={14} />
    </button>
  );
}
